import { mapState } from "vuex";
export const craftsmanIndexMixins = {
  computed: {
    craftsmanTopBarList() {
      let topbarList = [
        {
          name: "预约设置",
          isActive: false,
          path: "/craftsman/bookingsetting",
          icon:require("@/assets/img/menuIcons/icon-craftsmanbookingsetting.png")
        },
        {
          name: "手艺人管理",
          isActive: false,
          path: "/craftsman/manage",
          icon:require("@/assets/img/menuIcons/icon-craftsmanmanage.png")
        },
        {
          name: "手艺人排班",
          isActive: false,
          path: "/craftsman/schedule/manage",
          children: ["/craftsman/schedule/manage", "/craftsman/schedule/shiftManage"],
          icon:require("@/assets/img/menuIcons/icon-craftsmanschedulemanage.png")
        },
        // {
        //   name: "业绩统计",
        //   isActive: false,
        //   path: "/performanceStatistics",
        // },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
